import { Spin } from 'antd';
import './Spinner.scss';
import classNames from 'classnames';

interface ISpinnerProps {
  tip: string;
  size: 'small' | 'large' | 'default' | undefined;
  className?: string;
}

const Spinner: React.FC<ISpinnerProps> = ({ ...props }: ISpinnerProps) => {
  const { size, tip, className } = props;

  const spinnerClass = classNames(className, {
    'spinner-container': true,
  });

  return (
    <div className={spinnerClass}>
      <div className="spinner">
        <Spin tip={tip} size={size}>
          <div className="spinner-content" />
        </Spin>
      </div>
    </div>
  );
};

/** Default props. */
Spinner.defaultProps = {
  tip: 'Loading',
  size: 'large',
  className: '',
};

Spinner.displayName = 'Spinner';

export default Spinner;
